import React from 'react'
import ThemeBgSwitcher from './ThemeBgSwitcher'
import ThemeRoundedSwitcher from './ThemeRoundedSwitcher'
import ThemeStyleSwitcher from './ThemeStyleSwitcher'

const Footer = ({ themeColor, setThemeColor, setThemeRounded, colorTheme, setTheme }) => {
    return (
        <div className='flex flex-col gap-4 w-full'>
            <div className='flex justify-between items-center mx-5'>
                <ThemeBgSwitcher colorTheme={colorTheme} setTheme={setTheme} />
                <ThemeRoundedSwitcher setThemeRounded={setThemeRounded} />
            </div>
            <ThemeStyleSwitcher themeColor={themeColor} setThemeColor={setThemeColor} />
            <div className='bg-skin-fill p-4  text-center rounded-custom'>
                <h5 className='text-sm text-slate-100 dark:text-slate-100 font-bold'>&copy; DevSG. All rights reserved</h5>
            </div>
        </div>
    )
}

export default Footer